/**
 * Page access — see migration 144.
 *
 * A non-admin may open exactly the pages ticked on their employee record. A
 * page is keyed by its path without the slash ('sales', 'account-management'),
 * and the Dashboard, at '/', by 'dashboard'. The menu itself is `NAV` in
 * components/Shell.tsx; the Employees checklist is drawn from it, and the API
 * refuses any key it does not know (`api/src/lib/pages.ts`).
 */

/** The page key for a menu path or route. */
export const pageKey = (path: string): string => (path === '/' ? 'dashboard' : path.replace(/^\//, ''));
